/*
 * Pages JS document
 * Page-specific javascript.
 */

/**
 * Global namespace, contains all custom JS within sub-namespaces.
 * @namespace
 */
var ZOL = ZOL || {};

/**
 * Page binding functions.
 */
ZOL.pages = ZOL.pages || {};

/* Index
============================================================= */

ZOL.pages['index'] = function(el) {

	// Read the query string to get the requested filters
	var getFiltersFromURL = function() {
		var queryString = window.location.search;

		if (!queryString) return;

		// Build the array of filters and all their values
		var filters = queryString.substring(1).split('&').map(function(filter) {
			var nameValuePair = filter.split('=');
			return {
				name: nameValuePair[0],
				value: nameValuePair[1]
			};
		});

		return filters;
	};

	// Take an array of filters and update the query string
	var addFiltersToURL = function(filters) {
		var newQueryString = '';

		if (filters.length) {
			// Convert the array of objects into an array of strings
			var filterArray = filters.map(function(filter) {
				return filter.name + '=' + filter.value;
			});

			// Convert the array into a string and append to the query string
			newQueryString = '?' + filterArray.join('&');
		}

		// Update the URL
		history.pushState({}, '', window.location.pathname + newQueryString);
	}

	// Apply an array of filters generated from the query string
	var applyArrayOfFilters = function(filters) {
		// For each filter...
		for (var filterIndex in filters) {
			var name = filters[filterIndex].name;
			var $field = $filtersSection.find('.options[data-name="' + name + '"]');

			if (!$field.length) continue;

			var value = filters[filterIndex].value;
			var $checkboxButton = $field.find('.checkbox-button[data-value="' + value + '"]');

			if (!$checkboxButton.length) continue;

			$checkboxButton.click();
		}
	};

	// Automatically show filtered results according query string data
	var autoLoadFilters = function() {
		var desiredFilters = getFiltersFromURL();
		applyArrayOfFilters(desiredFilters);
	};

	var $productsSection = $('.section--products');
	var $productsContainer = $productsSection.find('.products');
	var $productTemplate = $productsContainer.find('.template--product');
	var $noResultsMessage = $productsContainer.find('.no-results-message');;
	var $products;

	// Format the price to add dollar sign and drop the cents
	var formatPrice = function(price) {
		return '$' + Number(price).toLocaleString('en-us');
	};

	// Convert string to kebab-case
	var toKebabCase = function(string) {
		return string.toLowerCase().trim().replace(' ', '-');
	};

	// Store all found product tags
	var tagSchema = {};

	// Add product tags as data attributes
	var addProductTags = function(product, tags) {
		var $currentProduct = $(product);

		for (var tag in tags) {
			var splitTag = tags[tag].split(':');

			// Get the label and value
			var label = splitTag[0].trim();
			var value = splitTag[1].trim();

			// Save this label to the tag schema object
			if (!tagSchema.hasOwnProperty(label)) {
				tagSchema[label] = [];
			}

			// Save this value to the tag schema object
			if (tagSchema[label].indexOf(value) === -1) {
				tagSchema[label].push(value);
			}

			// Either create a new attribute, or append to an existing one
			var dataAttribute = 'data-' + toKebabCase(label);
			if ($currentProduct.attr(dataAttribute) === undefined) {
				$currentProduct.attr(dataAttribute, toKebabCase(value));
			} else {
				$currentProduct.attr(dataAttribute, $currentProduct.attr(dataAttribute) + ' ' + toKebabCase(value));
			}
		}
	};

	// Get products from shopify
	function getProducts(){
		// Iterate through each page of the /products.json endpoint to get every product
		// Not "smartly" blanket grab everything as we iterate.

		// Vars
		var promiseArray = [];
		var products = [];
		var getProductsPromise = $.Deferred();

		// Number here represents the number of calls we make.
		// Start our initial pagination at page 1
		for (var i = 1;i<5;i++){
			promiseArray.push(_getData(i));
		}

		// Using the native JS way of handling the promises instead of jQuery .when
		Promise.all(promiseArray).then(function(){
			// Iterate through all the promises and add the data to our product array
			promiseArray.forEach(function(res) {
				var newProducts = res["responseJSON"].products; // Get array data from response
				products = products.concat(newProducts); // Merge existing products with this products call.
			});
			
			// Resolve promise returned from getProducts() and fill with all of our product data
			getProductsPromise.resolve(products);
		});

		// Performs the ajax request
		function _getData(page){
			var pageSize = 50; // Critical we know what the page size is
			var requestPromise = $.ajax({
				// Grab products from the "all-products" collection
				url : 'collections/all-products/products.json' + '?page=' + page + '&limit='+pageSize,
				type : 'get',
				dataType : 'json'
			});
			return requestPromise; // Returns the ajax promise
		}

		// This promise has to be resolved to get data out of the function
		return getProductsPromise;
	}

	function renderProduct(product){
		// Clone the product template
		var $newProduct = $productTemplate.clone().removeClass('template--product').addClass('product');

		// Customize the new product
		$newProduct.find('.product-wrapper').attr('href', '/products/' + product.handle);
		$newProduct.find('.product-wrapper').css('background-image', 'url("' + product.images[0].src + '")');
		$newProduct.find('.product-title').html(product.title);
		$newProduct.find('.product-price').html(formatPrice(product.variants[0].price));

		// Add a data attribute for each tag
		addProductTags($newProduct, product.tags);

		return $newProduct;
	}

	// All Zoltan Products
	var allZoltanProducts = getProducts();

	// When data is done, do stuff with it
	$.when(allZoltanProducts).done(function(data){
		// Product Data
		for(var key in data){
			$productsContainer.append($(renderProduct(data[key])));
		}

		// Alphabetize tag names and tag values
		var tagSchemaAlphabetized = {};
		Object.keys(tagSchema).sort().forEach(function(key) {
			tagSchemaAlphabetized[key] = tagSchema[key].sort();
		});

		buildFilters(tagSchemaAlphabetized);
		$products = $productsSection.find('.product');
		autoLoadFilters();
		updateGrid();
	});

	// Get the filters section
	var $filtersSection = $('.section--filters');

	// Filters elements
	var $filtersBar = $filtersSection.find('.filters-bar .title');
	var $selectionsContainer = $filtersSection.find('.selections');
	var $filtersClearButton = $filtersSection.find('.filters-bar .clear-all');
	var $filtersList = $filtersSection.find('.filters-list');

	var $viewAllSection = $('.section--view-all');
	var $viewAllButton = $viewAllSection.find('.view-all');

	// Create Disclosure for filters
	new ZOL.site.Disclosure($filtersBar, $filtersList);

	// Store the bitte fields
	var checkboxGroups = {};

	// Get filter selections as an array
	var getFilterSelections = function() {
		var filterSelections = [];

		// Start with the clear all button hidden
		$filtersClearButton.hide();

		// Start with the view all button hidden
		$viewAllButton.hide();

		// Start with the clear buttons hidden
		$selectionsContainer.css('display', 'none');
		$selectionsContainer.find('.selection').hide();

		// Iterate through each filter group
		for (var group in checkboxGroups) {
			var filterOutput = checkboxGroups[group].fetch();
			var $filterButton = $filtersSection.find('.filter .name[data-name="' + filterOutput.name + '"]');
			var $filterSelectedCount = $filterButton.find('.selected-count');

			// If no checkboxes within this group are checked
			if (!filterOutput.value.length) {
				// Clear out the count display and continue
				$filterSelectedCount.html('');
				continue;
			}

			// Update the count display
			$filterSelectedCount.html('(' + filterOutput.value.length + ' Selected)');

			// Iterate through each checked value
			for (value in filterOutput.value) {
				// Show the corresponding clear button
				$selectionsContainer.find('.selection[data-filter="' + filterOutput.name + '"][data-value="' + filterOutput.value[value] + '"]').show();

				// Save this selection to the array
				filterSelections.push({
					name: filterOutput.name,
					value: filterOutput.value[value]
				});
			}
		}

		if (filterSelections.length) {
			$selectionsContainer.css('display', 'flex');
			$filtersClearButton.show();
			$viewAllButton.show();
		}

		return filterSelections;
	};

	// Determine whether a product has a given tag
	var hasTag = function($product, tag) {
		if (!$product[0].hasAttribute('data-' + tag.name)) return false;

		return $product[0].getAttribute('data-' + tag.name).split(' ').indexOf(tag.value) !== -1;
	};

	// Determine whether to show or hide a product
	// * Logical structure: OR Gates within filter group, AND Gate between filter groups
	// * Example: (ring OR necklace OR earring) AND (male) AND (black OR red)
	var evaluateProduct = function($product, filterSelections) {
		// Is this product a match with the filter selections
		var isMatch = true;

		// Keep track of which filters this product matches (true/false)
		var filterMatches = {};

		// Go through each filter group that has a value
		for (var selection in filterSelections) {
			var tag = filterSelections[selection];

			// Set the initial value for this filter group as false
			if (!filterMatches.hasOwnProperty(tag.name)) {
				filterMatches[tag.name] = false;
			}

			// If the product has this tag, mark it as TRUE
			if (hasTag($product, tag)) {
				filterMatches[tag.name] = true;
			}
		}

		// Go through each filter group that has a value
		for (var selection in filterMatches) {
			// If there is even one FALSE, this product is not a match
			if (!filterMatches[selection]) {
				isMatch = false;
				break;
			}
		}

		return isMatch;
	};

	// Update results whenever the filter selections change
	var updateResults = function() {
		console.log('update results');
		// Get all checked checkboxes
		var filterSelections = getFilterSelections();

		// Update URL
		addFiltersToURL(filterSelections);

		// If there are no selections
		if (!filterSelections.length) {
			$products.show();
			updateGrid();
			return;
		}

		// Iterate through each product
		$products.each(function() {
			evaluateProduct($(this), filterSelections) ? $(this).show() : $(this).hide();
		});

		// Update the grid layout
		updateGrid();
	};

	// Build the filters
	var buildFilters = function(filters) {
		// Get all filters from tag schema
		for (var filterName in filters) {
			// Filter
			var $filter = $('<div class="filter"></div>');
			$filtersList.append($filter);

			// Filter Name
			var filterHandle = toKebabCase(filterName);
			var $filterButton = $('<button class="name" data-name="' + filterHandle + '"></button>');
			var $filterName = $('<span>' + filterName + '</span>');
			var $filterSelectedCount = $('<span class="selected-count"></span>');
			$filterButton.append($filterName).append($filterSelectedCount);
			$filter.append($filterButton);

			// Filter Options
			var $filterOptions = $('<div class="options" data-name="' + filterHandle + '"></div>');
			$filter.append($filterOptions);

			// Checkbox data
			var checkboxData = filters[filterName].map(function(item) {
				return {display: item, value: toKebabCase(item)};
			});

			// Create bitte checkboxes
			checkboxGroups[filterHandle] = bitte.ui.checkbox.create({
				name: filterHandle,
				options: checkboxData
			});

			// Listen for changes
			checkboxGroups[filterHandle].on('ui-change', updateResults);

			// Create a corresponding clear button for each checkbox
			for (var checkbox in checkboxData) {
				// Create button
				var $clear = $('<button class="selection" data-filter="' + filterHandle + '" data-value="' + checkboxData[checkbox].value + '"></button>');
				$clear.html('x ' + checkboxData[checkbox].display);

				// Start hidden
				$clear.hide();

				// Hide this selection on click
				$clear.on('click', function() {
					var bitteFilter = $filtersList.find('.options[data-name="' + $(this).data('filter') + '"]').find('.bitte-field');
					$(bitteFilter).setValue([{name: $(this).data('value'), value: false}]);
					$(this).hide();
					updateGrid();
				});

				// Add this button to the DOM
				$selectionsContainer.prepend($clear);
			}

			$filterOptions.append(checkboxGroups[filterHandle]);

			// Create Disclosure for filter
			new ZOL.site.Disclosure($filterButton, $filterOptions);
		}
	};

	// Clear all filters
	var clearAllFilters = function() {
		for (var group in checkboxGroups) {
			checkboxGroups[group].setValue(null);
		}
		updateGrid();
	};

	$filtersClearButton.on('click', clearAllFilters);
	$viewAllButton.on('click', clearAllFilters);

	// Update grid of boxes
	var updateGrid = function() {
		// Get box container and boxes
		var $boxContainer = $productsContainer;
		var $boxes = $products.filter(':visible');

		// If there are no matching products, reset height
		if ($boxes.length === 0) {
			$boxContainer.css('height', 'auto');
			$noResultsMessage.show();
			return;
		}

		// Hide the no results message
		$noResultsMessage.hide();

		// Get the box sizing variables from the container width
		var full = $boxContainer[0].getBoundingClientRect().width;
		var oneThird = full * .3333;
		var twoThirds = full * .6666;

		// The height of a complete set of 12 boxes
		var setHeight = full * 2;

		// The height to encompass all the boxes
		var boxContainerHeight;

		// Iterate through each box
		for (var index = 0; index < $boxes.length; index++) {
			// Current box
			var $box = $($boxes[index]);

			// The number of complete sets so far
			var setIndex = Math.floor(index / 12);

			// The height of the complete sets so far
			var offset = setIndex * setHeight;

			// If mobile, all boxes get the same sizing/positioning
			if (window.innerWidth < 1024) {
				$box.css({'top': full * index, 'left': 0, 'width': full, 'height': full});
				$boxContainer.css('height', full * index + full);
				continue;
			}

			// If desktop, assign each box a size and position according to its index
			if ((index + 1) % 12 === 1) {
				$box.css({'top': offset, 'left': 0, 'width': twoThirds, 'height': twoThirds});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 2) {
				$box.css({'top': offset, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 3) {
				$box.css({'top': offset + oneThird, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 4) {
				$box.css({'top': offset + twoThirds, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 5) {
				$box.css({'top': offset + twoThirds, 'left': oneThird, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 6) {
				$box.css({'top': offset + twoThirds, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 7) {
				$box.css({'top': offset + full, 'left': oneThird, 'width': twoThirds, 'height': twoThirds});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 8) {
				$box.css({'top': offset + full, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 9) {
				$box.css({'top': offset + full + oneThird, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 10) {
				$box.css({'top': offset + full + twoThirds, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			} else if ((index + 1) % 12 === 11) {
				$box.css({'top': offset + full + twoThirds, 'left': oneThird, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			} else if ((index + 1) % 12 === 0) {
				$box.css({'top': offset + full + twoThirds, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			}
		}

		$boxContainer.css('height', boxContainerHeight);
	};

	$(window).on('resize', updateGrid);
};


/* Archive Products
============================================================= */
ZOL.pages['page-archive'] = function(el) {

	// Read the query string to get the requested filters
	var getFiltersFromURL = function() {
		var queryString = window.location.search;

		if (!queryString) return;

		// Build the array of filters and all their values
		var filters = queryString.substring(1).split('&').map(function(filter) {
			var nameValuePair = filter.split('=');
			return {
				name: nameValuePair[0],
				value: nameValuePair[1]
			};
		});

		return filters;
	};

	// Take an array of filters and update the query string
	var addFiltersToURL = function(filters) {
		var newQueryString = '';

		if (filters.length) {
			// Convert the array of objects into an array of strings
			var filterArray = filters.map(function(filter) {
				return filter.name + '=' + filter.value;
			});

			// Convert the array into a string and append to the query string
			newQueryString = '?' + filterArray.join('&');
		}

		// Update the URL
		history.pushState({}, '', window.location.pathname + newQueryString);
	}

	// Apply an array of filters generated from the query string
	var applyArrayOfFilters = function(filters) {
		// For each filter...
		for (var filterIndex in filters) {
			var name = filters[filterIndex].name;
			var $field = $filtersSection.find('.options[data-name="' + name + '"]');

			if (!$field.length) continue;

			var value = filters[filterIndex].value;
			var $checkboxButton = $field.find('.checkbox-button[data-value="' + value + '"]');

			if (!$checkboxButton.length) continue;

			$checkboxButton.click();
		}
	};

	// Automatically show filtered results according query string data
	var autoLoadFilters = function() {
		var desiredFilters = getFiltersFromURL();
		applyArrayOfFilters(desiredFilters);
	};

	var $productsSection = $('.section--products');
	var $productsContainer = $productsSection.find('.products');
	var $productTemplate = $productsContainer.find('.template--product');
	var $noResultsMessage = $productsContainer.find('.no-results-message');;
	var $products;

	// Format the price to add dollar sign and drop the cents
	var formatPrice = function(price) {
		return '$' + Number(price).toLocaleString('en-us');
	};

	// Convert string to kebab-case
	var toKebabCase = function(string) {
		return string.toLowerCase().trim().replace(' ', '-');
	};

	// Store all found product tags
	var tagSchema = {};
 
	// Add product tags as data attributes
	var addProductTags = function(product, tags) {
		var $currentProduct = $(product);

		for (var tag in tags) {
			var splitTag = tags[tag].split(':');

			// Get the label and value
			var label = splitTag[0].trim();
			var value = splitTag[1].trim();

			// Save this label to the tag schema object
			if (!tagSchema.hasOwnProperty(label)) {
				tagSchema[label] = [];
			}

			// Save this value to the tag schema object
			if (tagSchema[label].indexOf(value) === -1) {
				tagSchema[label].push(value);
			}

			// Either create a new attribute, or append to an existing one
			var dataAttribute = 'data-' + toKebabCase(label);
			if ($currentProduct.attr(dataAttribute) === undefined) {
				$currentProduct.attr(dataAttribute, toKebabCase(value));
			} else {
				$currentProduct.attr(dataAttribute, $currentProduct.attr(dataAttribute) + ' ' + toKebabCase(value));
			}
		}
	};

	// Get products from shopify
	function getProducts(){
		// Iterate through each page of the /products.json endpoint to get every product
		// Not "smartly" blanket grab everything as we iterate.

		// Vars
		var promiseArray = [];
		var products = [];
		var getProductsPromise = $.Deferred();

		// Number here represents the number of calls we make.
		// Start our initial pagination at page 1
		for (var i = 1;i<5;i++){
			promiseArray.push(_getData(i));
		}

		// Using the native JS way of handling the promises instead of jQuery .when
		Promise.all(promiseArray).then(function(){
			// Iterate through all the promises and add the data to our product array
			promiseArray.forEach(function(res) {
				var newProducts = res["responseJSON"].products; // Get array data from response
				products = products.concat(newProducts); // Merge existing products with this products call.
			});
			
			// Resolve promise returned from getProducts() and fill with all of our product data
			getProductsPromise.resolve(products);
		});

		// Performs the ajax request
		function _getData(page){
			var pageSize = 50; // Critical we know what the page size is
			var requestPromise = $.ajax({
				// Grab products from the "archive products" collection
				url : '/collections/archived-products/products.json' + '?page=' + page + '&limit='+pageSize,
				type : 'get',
				dataType : 'json'
			});
			return requestPromise; // Returns the ajax promise
		}

		// This promise has to be resolved to get data out of the function
		return getProductsPromise;
	}

	function renderProduct(product){
		// Clone the product template
		var $newProduct = $productTemplate.clone().removeClass('template--product').addClass('product');

		// Customize the new product
		$newProduct.find('.product-wrapper').attr('href', '/products/' + product.handle);
		$newProduct.find('.product-wrapper').css('background-image', 'url("' + product.images[0].src + '")');
		$newProduct.find('.product-title').html(product.title);
		//$newProduct.find('.product-price').html(formatPrice(product.variants[0].price));
		$newProduct.find('.page--page-archive .section--products .product-price').remove();

		// Add a data attribute for each tag
		addProductTags($newProduct, product.tags);

		return $newProduct;
	}

	// All Zoltan Products
	var allZoltanProducts = getProducts();

	// When data is done, do stuff with it
	$.when(allZoltanProducts).done(function(data){

		// Product Data
		for(var key in data){
			$productsContainer.append($(renderProduct(data[key])));
		}

		// Alphabetize tag names and tag values
		var tagSchemaAlphabetized = {};
		Object.keys(tagSchema).sort().forEach(function(key) {
			tagSchemaAlphabetized[key] = tagSchema[key].sort();
		});

		buildFilters(tagSchemaAlphabetized);
		$products = $productsSection.find('.product');
		autoLoadFilters();
		updateGrid();
	});

	// Get the filters section
	var $filtersSection = $('.section--filters');

	// Filters elements
	var $filtersBar = $filtersSection.find('.filters-bar .title');
	var $selectionsContainer = $filtersSection.find('.selections');
	var $filtersClearButton = $filtersSection.find('.filters-bar .clear-all');
	var $filtersList = $filtersSection.find('.filters-list');

	var $viewAllSection = $('.section--view-all');
	var $viewAllButton = $viewAllSection.find('.view-all');

	// Create Disclosure for filters
	new ZOL.site.Disclosure($filtersBar, $filtersList);

	// Store the bitte fields
	var checkboxGroups = {};

	// Get filter selections as an array
	var getFilterSelections = function() {
		var filterSelections = [];

		// Start with the clear all button hidden
		$filtersClearButton.hide();

		// Start with the view all button hidden
		$viewAllButton.hide();

		// Start with the clear buttons hidden
		$selectionsContainer.css('display', 'none');
		$selectionsContainer.find('.selection').hide();

		// Iterate through each filter group
		for (var group in checkboxGroups) {
			var filterOutput = checkboxGroups[group].fetch();
			var $filterButton = $filtersSection.find('.filter .name[data-name="' + filterOutput.name + '"]');
			var $filterSelectedCount = $filterButton.find('.selected-count');

			// If no checkboxes within this group are checked
			if (!filterOutput.value.length) {
				// Clear out the count display and continue
				$filterSelectedCount.html('');
				continue;
			}

			// Update the count display
			$filterSelectedCount.html('(' + filterOutput.value.length + ' Selected)');

			// Iterate through each checked value
			for (value in filterOutput.value) {
				// Show the corresponding clear button
				$selectionsContainer.find('.selection[data-filter="' + filterOutput.name + '"][data-value="' + filterOutput.value[value] + '"]').show();

				// Save this selection to the array
				filterSelections.push({
					name: filterOutput.name,
					value: filterOutput.value[value]
				});
			}
		}

		if (filterSelections.length) {
			$selectionsContainer.css('display', 'flex');
			$filtersClearButton.show();
			$viewAllButton.show();
		}

		return filterSelections;
	};

	// Determine whether a product has a given tag
	var hasTag = function($product, tag) {
		if (!$product[0].hasAttribute('data-' + tag.name)) return false;

		return $product[0].getAttribute('data-' + tag.name).split(' ').indexOf(tag.value) !== -1;
	};

	// Determine whether to show or hide a product
	// * Logical structure: OR Gates within filter group, AND Gate between filter groups
	// * Example: (ring OR necklace OR earring) AND (male) AND (black OR red)
	var evaluateProduct = function($product, filterSelections) {
		// Is this product a match with the filter selections
		var isMatch = true;

		// Keep track of which filters this product matches (true/false)
		var filterMatches = {};

		// Go through each filter group that has a value
		for (var selection in filterSelections) {
			var tag = filterSelections[selection];

			// Set the initial value for this filter group as false
			if (!filterMatches.hasOwnProperty(tag.name)) {
				filterMatches[tag.name] = false;
			}

			// If the product has this tag, mark it as TRUE
			if (hasTag($product, tag)) {
				filterMatches[tag.name] = true;
			}
		}

		// Go through each filter group that has a value
		for (var selection in filterMatches) {
			// If there is even one FALSE, this product is not a match
			if (!filterMatches[selection]) {
				isMatch = false;
				break;
			}
		}

		return isMatch;
	};

	// Update results whenever the filter selections change
	var updateResults = function() {
		// Get all checked checkboxes
		var filterSelections = getFilterSelections();

		// Update URL
		addFiltersToURL(filterSelections);

		// If there are no selections
		if (!filterSelections.length) {
			$products.show();
			updateGrid();
			return;
		}

		// Iterate through each product
		$products.each(function() {
			evaluateProduct($(this), filterSelections) ? $(this).show() : $(this).hide();
		});

		// Update the grid layout
		updateGrid();
	};

	// Build the filters
	var buildFilters = function(filters) {
		// Get all filters from tag schema
		for (var filterName in filters) {
			// Filter
			var $filter = $('<div class="filter"></div>');
			$filtersList.append($filter);

			// Filter Name
			var filterHandle = toKebabCase(filterName);
			var $filterButton = $('<button class="name" data-name="' + filterHandle + '"></button>');
			var $filterName = $('<span>' + filterName + '</span>');
			var $filterSelectedCount = $('<span class="selected-count"></span>');
			$filterButton.append($filterName).append($filterSelectedCount);
			$filter.append($filterButton);

			// Filter Options
			var $filterOptions = $('<div class="options" data-name="' + filterHandle + '"></div>');
			$filter.append($filterOptions);

			// Checkbox data
			var checkboxData = filters[filterName].map(function(item) {
				return {display: item, value: toKebabCase(item)};
			});

			// Create bitte checkboxes
			checkboxGroups[filterHandle] = bitte.ui.checkbox.create({
				name: filterHandle,
				options: checkboxData
			});

			// Listen for changes
			checkboxGroups[filterHandle].on('ui-change', updateResults);

			// Create a corresponding clear button for each checkbox
			for (var checkbox in checkboxData) {
				// Create button
				var $clear = $('<button class="selection" data-filter="' + filterHandle + '" data-value="' + checkboxData[checkbox].value + '"></button>');
				$clear.html('x ' + checkboxData[checkbox].display);

				// Start hidden
				$clear.hide();

				// Hide this selection on click
				$clear.on('click', function() {
					var bitteFilter = $filtersList.find('.options[data-name="' + $(this).data('filter') + '"]').find('.bitte-field');
					$(bitteFilter).setValue([{name: $(this).data('value'), value: false}]);
					$(this).hide();
					updateGrid();
				});

				// Add this button to the DOM
				$selectionsContainer.prepend($clear);
			}

			$filterOptions.append(checkboxGroups[filterHandle]);

			// Create Disclosure for filter
			new ZOL.site.Disclosure($filterButton, $filterOptions);
		}
	};

	// Clear all filters
	var clearAllFilters = function() {
		for (var group in checkboxGroups) {
			checkboxGroups[group].setValue(null);
		}
		updateGrid();
	};

	$filtersClearButton.on('click', clearAllFilters);
	$viewAllButton.on('click', clearAllFilters);

	// Update grid of boxes
	var updateGrid = function() {
		// Get box container and boxes
		var $boxContainer = $productsContainer;
		var $boxes = $products.filter(':visible');

		// If there are no matching products, reset height
		if ($boxes.length === 0) {
			$boxContainer.css('height', 'auto');
			$noResultsMessage.show();
			return;
		}

		// Hide the no results message
		$noResultsMessage.hide();

		// Get the box sizing variables from the container width
		var full = $boxContainer[0].getBoundingClientRect().width;
		var oneThird = full * .3333;
		var twoThirds = full * .6666;

		// The height of a complete set of 12 boxes
		var setHeight = full * 2;

		// The height to encompass all the boxes
		var boxContainerHeight;

		// Iterate through each box
		for (var index = 0; index < $boxes.length; index++) {
			// Current box
			var $box = $($boxes[index]);

			// The number of complete sets so far
			var setIndex = Math.floor(index / 12);

			// The height of the complete sets so far
			var offset = setIndex * setHeight;

			// If mobile, all boxes get the same sizing/positioning
			if (window.innerWidth < 1024) {
				$box.css({'top': full * index, 'left': 0, 'width': full, 'height': full});
				$boxContainer.css('height', full * index + full);
				continue;
			}

			// If desktop, assign each box a size and position according to its index
			if ((index + 1) % 12 === 1) {
				$box.css({'top': offset, 'left': 0, 'width': twoThirds, 'height': twoThirds});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 2) {
				$box.css({'top': offset, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 3) {
				$box.css({'top': offset + oneThird, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + twoThirds;
			} else if ((index + 1) % 12 === 4) {
				$box.css({'top': offset + twoThirds, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 5) {
				$box.css({'top': offset + twoThirds, 'left': oneThird, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 6) {
				$box.css({'top': offset + twoThirds, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full;
			} else if ((index + 1) % 12 === 7) {
				$box.css({'top': offset + full, 'left': oneThird, 'width': twoThirds, 'height': twoThirds});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 8) {
				$box.css({'top': offset + full, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 9) {
				$box.css({'top': offset + full + oneThird, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + full + twoThirds;
			} else if ((index + 1) % 12 === 10) {
				$box.css({'top': offset + full + twoThirds, 'left': 0, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			} else if ((index + 1) % 12 === 11) {
				$box.css({'top': offset + full + twoThirds, 'left': oneThird, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			} else if ((index + 1) % 12 === 0) {
				$box.css({'top': offset + full + twoThirds, 'left': twoThirds, 'width': oneThird, 'height': oneThird});
				boxContainerHeight = offset + setHeight;
			}
		}

		$boxContainer.css('height', boxContainerHeight);
	};

	$(window).on('resize', updateGrid);
};

/* Product
============================================================= */

ZOL.pages['product'] = function(el) {

	// Initialize the normal slick slider
	$('.slick--normal .slides').slick({
		fade: true,
		swipe: false,
		arrows: false,
		dots: true,
		appendDots: '.slick--normal .dots',
		asNavFor: '.slick--fullscreen .slides'
	});

	// Initialize the fullscreen slick slider
	$('.slick--fullscreen .slides').slick({
		fade: true,
		swipe: false,
		arrows: false,
		dots: true,
		appendDots: '.slick--fullscreen .dots',
		asNavFor: '.slick--normal .slides'
	});

	// Keydown handler
	function slickKeydownHandler(event) {
		if (event.which === 27) {
			closeSlickFullscreen();
		}
	}

	// Open the fullscreen slick slider
	function openSlickFullscreen() {
		$('html').addClass('no-scroll');
		$('.slick--fullscreen').addClass('active');
		$(document).on('keydown', slickKeydownHandler);

		// Disable the main menu
		$('.site--header').css('pointer-events', 'none');
		$('.site--header .menu-wrapper').fadeOut(500);
	}

	// Close the fullscreen slick slider
	function closeSlickFullscreen() {
		$('html').removeClass('no-scroll');
		$('.slick--fullscreen').removeClass('active');
		$(document).off('keydown', slickKeydownHandler);

		// Enable the main menu
		$('.site--header').css('pointer-events', 'auto');
		$('.site--header .menu-wrapper').fadeIn(500);
	}

	// On image click, open fullscreen
	$('.slick--normal .slides .slide .image').on('click', openSlickFullscreen);

	// On close button click, close fullscreen
	$('.fullscreen-close-button').on('click', closeSlickFullscreen);

};
